/**
 * Return search results nodes with extra meta data added to nodes
 */
export function transformSearchResultToTreeNodes(
  rawSearchResultNodes: ReadonlyArray<any>,
  opts: {
    treeNodesShouldOpen?: boolean;
  } = {}
): ReadonlyArray<any> {
  const { treeNodesShouldOpen = false } = opts;
  if (!Array.isArray(rawSearchResultNodes) || !rawSearchResultNodes.length) {
    return [];
  }

  let supplierPersonIndex = 0;

  return rawSearchResultNodes.map(rawSearchResultNode => {
    if (rawSearchResultNode.isSupplier || !rawSearchResultNode.isPerson) {
      const rawNodeWithId = {
        ...rawSearchResultNode,
        matchesDiscoveryFilters: true,
        open: treeNodesShouldOpen ? true : undefined,
        uiNodeId: `search-result-supplier-${rawSearchResultNode.id}`
      };
      return Array.isArray(rawNodeWithId.children) && rawNodeWithId.children.length
        ? {
            ...rawNodeWithId,
            children: transformSearchResultToTreeNodes(rawNodeWithId.children, opts)
          }
        : rawNodeWithId;
    }

    if (rawSearchResultNode.isPerson) {
      return {
        ...rawSearchResultNode,
        hasSupplierSibling: rawSearchResultNodes.some(node => node.isSupplier),
        matchesDiscoveryFilters: true,
        supplierPersonIndex: supplierPersonIndex++,
        uiNodeId: `search-result-person-${rawSearchResultNode.personKey}`
      };
    }

    // don't think this happens, but just return a node if its missing isSupplier or isPerson
    return rawSearchResultNode;
  });
}
